export interface Role {
  id: string;
  name: string;
  type: string;
  enable: number;
  createBy: number;
  createAt: number;
  updateBy: number;
  updateAt: number;
}

export enum RoleType {
  System = 'system',
  Common = 'common',
  Project = 'project',
}

export const RoleTypeMap = [
  { label: '系统', value: RoleType.System, color: 'red' },
  { label: '公共', value: RoleType.Common, color: 'green' },
  { label: '项目', value: RoleType.Project, color: 'blue' },
];

export enum RoleEnable {
  Enable = 0,
  Disable = 1,
}

export const RoleEnableMap = [
  { label: '正常', value: RoleEnable.Enable, color: '#2db7f5' },
  { label: '停用', value: RoleEnable.Disable, color: 'red' },
];
